import MobileSliderPagesWrapper from "../../components/MobileSliderPagesWrapper.jsx";
import MobileSliderPagesHeader from "../../components/MobileSliderPagesHeader.jsx";
import { MobileSliderPagesContentStyled } from "../../components/styled/MobileSliderPagesStyled.js";
import MobileHistory from "../../../MobileHistory/MobileHistory";
import { useLangContext } from "../../../../../providers/LangProvider/LangProviderContext";

function SlideMobileHistory() {
    const {getLangPath} = useLangContext();

    return <MobileSliderPagesWrapper backgroundColor="var(--background-base)">
        <MobileSliderPagesHeader goBack>
            <h4 className="mb-0 text-center fw600 f16">{getLangPath('lite_version.home.history')}</h4>
        </MobileSliderPagesHeader>
        <MobileSliderPagesContentStyled className="px-0">
            <MobileHistory/>
        </MobileSliderPagesContentStyled>
    </MobileSliderPagesWrapper>
}

export default SlideMobileHistory;
